import { Component, OnInit, Input } from '@angular/core';
import { CourseObjectivesService } from '../course-objectives.service';

@Component({
    selector: 'app-course-objectives',
    templateUrl: './course-objectives.component.html',
    styleUrls: ['./course-objectives.component.scss'],
})
export class CourseObjectivesComponent implements OnInit {
    @Input() display;

    constructor(private courseObjectivesService: CourseObjectivesService) {}

    ngOnInit(): void {
        this.get();
    }

    get(): void {
        this.courseObjectivesService.get();
    }

    collapse(): void {
        if (this.isEditable) return;
        this.display = !this.display;
    }

    reload(): void {
        if (this.isEditable) return;
        this.get();
    }

    add(): void {
        if (this.isEditable) return;
        this.display = true;
        this.courseObjectivesService.isAdd = true;
        this.courseObjectivesService.isEditable = true;
    }

    get isAdd() {
        return this.courseObjectivesService.isAdd;
    }

    get isEditable() {
        return this.courseObjectivesService.isEditable;
    }

    get objectives() {
        return this.courseObjectivesService.objectives;
    }

    get isLoading() {
        return this.courseObjectivesService.isLoading;
    }

    get errorMessage() {
        return this.courseObjectivesService.errorMessage;
    }
}